import { LoanOffersModule } from './../loan/loan-module.module';
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { CalculatorFormComponent } from './short-sweet/calculator-form/calculator-form.component';
import { CalculatorsRoutingModule } from './calculators-routing.module';
import { SharedModule } from 'app/shared/shared.module';
import { CalculatorTableComponent } from './short-sweet/calculator-table/calculator-table.component';
import { BalanceTransferOffersComponent } from 'app/calculators/home-loan-comparison-calculator/balance-transfer-offers/balance-transfer-offers.component';
import { CalculatorLeftSideMenuComponent } from 'app/calculators/home-loan-comparison-calculator/calculator-left-side-menu/calculator-left-side-menu.component';
import { ProfileBasedOffersComponent } from 'app/calculators/home-loan-comparison-calculator/profile-based-offers/profile-based-offers.component';
import { GroupOffersComponent } from 'app/calculators/home-loan-comparison-calculator/group-offers/group-offers.component';
import { PropertyBasedOffersComponent } from 'app/calculators/home-loan-comparison-calculator/property-based-offers/property-based-offers.component';
import { ChatToGetOffersComponent } from 'app/calculators/home-loan-comparison-calculator/chat-to-get-offers/chat-to-get-offers.component';
import { CallToGetOffersComponent } from 'app/calculators/home-loan-comparison-calculator/call-to-get-offers/call-to-get-offers.component';
import { BankRateCalculationComponent } from 'app/calculators/home-loan-comparison-calculator/bank-rate-calculation/bank-rate-calculation.component';
import { BankRateCalculationResultComponent } from 'app/calculators/home-loan-comparison-calculator/bank-rate-calculation-result/bank-rate-calculation-result.component';
import { BankComparisonSideMenuComponent } from './home-loan-comparison-calculator/bank-comparison-side-menu/bank-comparison-side-menu.component';
import { QuestionsComponent } from './home-loan-comparison-calculator/questions/questions.component';
import { ProductsModule } from 'app/products/products.module';
import { CalculatorService } from 'app/calculators/calculator.service';
import { DynamicProductsComponent } from './home-loan-comparison-calculator/dynamic-products/dynamic-products.component';
import { ApplyLoanPopUpComponent } from './home-loan-comparison-calculator/apply-loan-pop-up/apply-loan-pop-up.component';
import { OfferPopUpComponent } from './home-loan-comparison-calculator/offer-pop-up/offer-pop-up.component';
import { LoanApplicationFormComponent } from './loan-application-form/loan-application-form.component';
import { NKDatetimeModule } from "ng2-datetime/ng2-datetime";
import { OwlModule } from 'ng2-owl-carousel';

@NgModule({
  imports: [
    CommonModule,
    CalculatorsRoutingModule,
    SharedModule,
    ProductsModule,
    LoanOffersModule,
    NKDatetimeModule,
    OwlModule
 ],
  declarations: [
  CalculatorFormComponent,
  CalculatorTableComponent,
  BalanceTransferOffersComponent,
  CalculatorLeftSideMenuComponent,
  ProfileBasedOffersComponent,
  GroupOffersComponent,
  PropertyBasedOffersComponent,
  ChatToGetOffersComponent,
  CallToGetOffersComponent,
  BankRateCalculationResultComponent,
  BankComparisonSideMenuComponent,
  QuestionsComponent,
  DynamicProductsComponent,
  ApplyLoanPopUpComponent,
  OfferPopUpComponent,
  LoanApplicationFormComponent,
  
],
  entryComponents: [ BalanceTransferOffersComponent, ProfileBasedOffersComponent,
    GroupOffersComponent, PropertyBasedOffersComponent, GroupOffersComponent, PropertyBasedOffersComponent,
    ChatToGetOffersComponent, CallToGetOffersComponent, QuestionsComponent, ApplyLoanPopUpComponent,
    BankRateCalculationComponent],

    providers: [ DatePipe ]
})
export class CalculatorsModule { }



// WEBPACK FOOTER //
// ./src/app/calculators/calculators-module.module.ts